import React from "react";
import { Star } from "lucide-react";

export default function StarRating({ value = 0, onChange, size = 20, readOnly = false, className = "" }) {
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= value;
        return (
          <button
            key={n}
            type="button"
            data-testid={`star-${n}`}
            onClick={() => !readOnly && onChange?.(n)}
            disabled={readOnly}
            className={`p-0.5 transition-transform ${readOnly ? "cursor-default" : "hover:scale-110 cursor-pointer"}`}
            aria-label={`${n} stars`}
          >
            <Star
              size={size}
              strokeWidth={1.5}
              fill={filled ? "#143122" : "none"}
              color={filled ? "#143122" : "#1A1F1C"}
            />
          </button>
        );
      })}
    </div>
  );
}
